// Returns true if string is ZIP code-shaped (5 digits)
export const isZipCode = (zip: string) => {
  const pattern = /^[0-9]{5}$/;

  return pattern.test(zip);
};
